export enum InputType {
  PhoneNumber = 0,
  Email = 1,
}

export const getPlainText = (htmlString: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc.body.textContent || '';
};
